import ProjectNamespaceCreateRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceCreateRequest";
import { CreateNamespaceModel } from "../models";

export const mapCreateNamespaceRequest = (request: CreateNamespaceModel, projectId: number) =>
  new ProjectNamespaceCreateRequest({
    ProjectId: projectId,
    Name: request.Name,
    IconId: request.IconId,
    ColorId: request.IconColorId,
    AdminIds: request.AdminIds,
    EmployeeIds: request.TeamIds
  });
